import { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { PageTitle } from '../../../_metronic/layout/core';
import { LogsTimeline } from '../../modules/logs';
import { retrieveLeadDistributor } from '../../modules/lead-distributors/services/LeadDistributorCRUD';
import { LeadDistributorModel } from '../../modules/lead-distributors/models/LeadDistributorModel';

type RouteParams = {
  leadDistributorId: string;
};

const LeadDistributorLogsPage: FC = () => {
  const intl = useIntl();
  const { leadDistributorId } = useParams<RouteParams>();
  const [leadDistributor, setLeadDistributor] =
    useState<LeadDistributorModel | null>(null);

  useEffect(() => {
    async function fetchLeadDistributor() {
      try {
        const { data } = await retrieveLeadDistributor(
          Number(leadDistributorId)
        );
        setLeadDistributor(data);
      } catch (error) {
        console.warn(error);
      }
    }
    if (leadDistributorId) {
      fetchLeadDistributor();
    }
  }, [leadDistributorId]);

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'logs.title' })}
      </PageTitle>
      <LogsTimeline
        kind="lead-distributor"
        id={Number(leadDistributorId)}
        entityName={leadDistributor?.name}
      />
    </>
  );
};

export { LeadDistributorLogsPage };
